import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {
  public title: string;
  public text: string;
  public cancelButtonLabel: string;
  public confirmButtonLabel: string;
  public showCancelButton: boolean;
  public showConfirmButton: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { name: string }, private dialogRef: MatDialogRef<AlertDialogComponent>) {
    const defaultValues = {
      title: 'ALERT',
      text: 'CHANGE THIS ALERT',
      cancelButtonLabel: 'CANCEL',
      confirmButtonLabel: 'CONFIRM',
      showCancelButton: false,
      showConfirmButton: true,
    };
    const values: any = {
      ...defaultValues,
      ...data,
    };

    this.title = values.title;
    this.text = values.text;
    this.confirmButtonLabel = values.confirmButtonLabel;
    this.cancelButtonLabel = values.cancelButtonLabel;
    this.showConfirmButton = values.showConfirmButton;
    this.showCancelButton = values.showCancelButton;
  }

  closeDialog() {
    this.dialogRef.close({data: 'confirmation'});
  }
}
